import { api } from '@/lib/api'

/**
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchCommandDashboard() {
  const { data } = await api.get('/command/dashboard')
  return data.data
}

/**
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchCommandLive() {
  const { data } = await api.get('/command/live')
  return data.data
}

/**
 * @returns {Promise<{ items: Array<Record<string, unknown>> }>}
 */
export async function fetchCommandAttention() {
  const { data } = await api.get('/command/attention')
  return data.data
}

/**
 * @param {'today' | 'week' | 'month'} period
 * @returns {Promise<Record<string, unknown>>}
 */
export async function fetchCommandAnalytics(period) {
  const { data } = await api.get('/command/analytics', { params: { period } })
  return data.data
}

/**
 * @param {string} alertId
 * @param {number} [snoozeMinutes]
 */
export async function dismissCommandAttention(alertId, snoozeMinutes = 240) {
  const { data } = await api.post(`/command/attention/${encodeURIComponent(alertId)}/dismiss`, {
    snooze_minutes: snoozeMinutes,
  })
  return data.data
}

/**
 * @param {Record<string, unknown>} prev
 * @param {Record<string, unknown>} live
 * @returns {Record<string, unknown>}
 */
export function mergeCommandLivePayload(prev, live) {
  if (!prev || !live) return prev

  return {
    ...prev,
    meta: {
      ...(prev.meta ?? {}),
      server_now: live.meta?.server_now ?? prev.meta?.server_now,
    },
    hero: {
      ...(prev.hero ?? {}),
      salon_pulse: live.salon_pulse ?? prev.hero?.salon_pulse,
    },
    floor: live.floor ?? prev.floor,
    live_operations: live.live_operations ?? prev.live_operations,
    timeline: live.timeline ?? prev.timeline,
    kpis: live.kpis ?? prev.kpis,
  }
}
